export default {"src":"/_next/static/media/BB.6086d224.svg","height":18,"width":18};